import {
  fetchGet,
  fetchPost,
  fetchPut,
  jsonToQueryParam
} from "./CommonServiceUtils";
import { Constants } from "@/constants";
import {
  TCampaignGetRequest,
  TCampaignGetResponse,
  TCampaignCreateRequest,
  TCampaignCreateResponse,
  TContentSuggestionRequest,
  TContentSuggestionResponse,
  TCampaignsCountResponse,
  TCampaignUpdateRequest,
  TCampaignUpdateResponse,
  TTemplateGetRequest,
  TTemplateGetResponse,
  TCampaignModelJSON,
  TCampaignROITransactionsRequest,
  TCampaignROITransactionsResponse,
  TCampaignROICustomersRequest,
  TCampaignROICustomersResponse,
  TCampaignsSMSCountResponse,
  TCampaignFilterRequest,
  TCampaignFilterResponse,
  TCampaignsSMSCountRequest,
  TCampaignConversionRateResponse
} from "@shoutout-labs/market_buzz_crm_types";

const getCampaigns = (
  queryObj: TCampaignGetRequest
): Promise<TCampaignGetResponse> => {
  return fetchGet(
    `${Constants.REACT_APP_API_BASE_URL}campaigns?${jsonToQueryParam(queryObj)}`
  );
};

const getCampaignsCount = (): Promise<TCampaignsCountResponse> => {
  return fetchGet(`${Constants.REACT_APP_API_BASE_URL}campaigns/count`);
};

const createCampaign = async (
  payload: TCampaignCreateRequest
): Promise<TCampaignCreateResponse> => {
  return await fetchPost(
    `${Constants.REACT_APP_API_BASE_URL}campaigns`,
    payload
  );
};

const updateCampaign = async (
  payload: TCampaignUpdateRequest,
  campaignId: string
): Promise<TCampaignUpdateResponse> => {
  return fetchPut(
    `${Constants.REACT_APP_API_BASE_URL}campaigns/${campaignId}`,
    payload
  );
};

const regenerateContent = (
  payload: TContentSuggestionRequest
): Promise<TContentSuggestionResponse> => {
  return fetchPost(
    `${Constants.REACT_APP_API_BASE_URL}campaigns/content-suggesion`,
    payload
  );
};

const getTemplates = (
  queryObj: TTemplateGetRequest
): Promise<TTemplateGetResponse> => {
  return fetchGet(
    `${Constants.REACT_APP_API_BASE_URL}campaigns/templates?${jsonToQueryParam(queryObj)}`
  );
};

const getCampaignById = (id: string): Promise<TCampaignModelJSON> => {
  return fetchGet(`${Constants.REACT_APP_API_BASE_URL}campaigns/${id}`);
};

const getCampaignRoiTransactions = (
  queryObj: TCampaignROITransactionsRequest
): Promise<TCampaignROITransactionsResponse> => {
  return fetchGet(
    `${Constants.REACT_APP_API_BASE_URL}campaigns/roi/transactions?${jsonToQueryParam(queryObj)}`
  );
};

const getCampaignRoiCustomers = (
  queryObj: TCampaignROICustomersRequest
): Promise<TCampaignROICustomersResponse> => {
  return fetchGet(
    `${Constants.REACT_APP_API_BASE_URL}campaigns/roi/customers?${jsonToQueryParam(queryObj)}`
  );
};

const getFilteredCampaigns = async (
  queryObj: TCampaignFilterRequest
): Promise<TCampaignFilterResponse> => {
  return fetchGet(
    `${Constants.REACT_APP_API_BASE_URL}campaigns/filter?${jsonToQueryParam(queryObj)}`
  );
};

const getTotalSMSCount = async (
  queryObj: TCampaignsSMSCountRequest
): Promise<TCampaignsSMSCountResponse> => {
  return fetchGet(
    `${Constants.REACT_APP_API_BASE_URL}campaigns/sms-count?${jsonToQueryParam(queryObj)}`
  );
};

const getCampaignStats = async (
  campaignType: string,
  campaignId?: string
): Promise<TCampaignConversionRateResponse> => {
  const queryParams: Record<string, string> = {
    campaignType
  };

  if (campaignId) {
    queryParams.campaignId = campaignId;
  }

  return fetchGet(
    `${Constants.REACT_APP_API_BASE_URL}campaigns/campaign-stats?${jsonToQueryParam(queryParams)}`
  );
};

export {
  getCampaigns,
  createCampaign,
  regenerateContent,
  getCampaignsCount,
  updateCampaign,
  getTemplates,
  getCampaignById,
  getCampaignRoiTransactions,
  getCampaignRoiCustomers,
  getFilteredCampaigns,
  getTotalSMSCount,
  getCampaignStats
};
